import angular from 'angular';

import { styledCheckboxComponent } from './styledCheckbox';
import { styledRadioComponent } from './styledRadio';
import './fields.scss';

/*******************************************************************************
* $Id: fields.js 20525 2020-11-06 21:36:39Z sthames $
/**
* @ngdoc    overview
* @name     csm.ui.fields
* @description
* UI dom input fields.
*******************************************************************************/
export default angular
  .module('csm.ui.fields', [])
  .component('styledCheckbox', styledCheckboxComponent)
  .component('styledRadio', styledRadioComponent)
  .name;

